import React from 'react'

import { BlueArrowIcon } from 'components/CasStudyComponent/icon'
import { Container } from 'react-bootstrap'
import styles from './ProvenChannel.module.css'

export interface ProvenChannelItem {
  id?: string
  text: React.ReactNode
}

export interface ProvenChannelData {
  title: string
  description?: string
  challenges: ProvenChannelItem[]
}

interface ProvenChannelSectionProps {
  data: ProvenChannelData
  theme?: 'light' | 'dark'
  titleClass?: string
  descriptionClass?: string
}

const ProvenChannelSection: React.FC<ProvenChannelSectionProps> = ({
  data,
  theme = 'light',
  titleClass = '',
  descriptionClass = '',
}) => {
  const { title, challenges, description } = data
  const isDark = theme === 'dark'

  return (
    <section
      className={[
        styles.sectionWrapper,
        styles.sectionBorder,
        isDark ? styles.darkSection : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <Container>
        <div className={styles.sectionTitleWrap}>
          <div className="row">
            <div className="col-12">
              <h2
                className={`${styles.sectionTitle} ${titleClass} ${isDark ? 'text-white' : 'text-black'
                  } mb-3`}
              >
                {title}
              </h2>
              <p
                className={`${styles.sectionSubTitle} ${descriptionClass} ${isDark ? 'text-white' : 'text-black'
                  } mb-0`}
              >
                {description}
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            {challenges.map((item) => {
              return (
                <div
                  key={item.id ?? String(item.text)}
                  className={`${styles.challengeCard} d-flex align-items-center`}
                >
                  <div className="">
                    <BlueArrowIcon />
                  </div>
                  <p className={`mb-0 ms-3 ${styles.challengeCardText}`}>
                    {item.text}
                  </p>
                </div>
              )
            })}
          </div>
        </div>
      </Container>
    </section>
  )
}

export default ProvenChannelSection
